import { render, staticRenderFns } from "./ComparePage.vue?vue&type=template&id=76540c92&scoped=true&"
import script from "./ComparePage.vue?vue&type=script&lang=js&"
export * from "./ComparePage.vue?vue&type=script&lang=js&"
import style0 from "./ComparePage.vue?vue&type=style&index=0&id=76540c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76540c92",
  null
  
)

export default component.exports